// Year range and default-state constants for the Hansen yearly forest-loss layer.
// Lives in common/ so both the store (UX state) and the views/ side (slider, layer
// registration) can import from a single source of truth.
export const HANSEN_YEARLY_START = 2001;
export const HANSEN_YEARLY_END = 2025;

// Initial selected range when the user first toggles the layer on. Mirrors the
// previous combined Hansen EUDR layer so the on-screen pixels look familiar.
export const HANSEN_YEARLY_DEFAULT_RANGE: [number, number] = [2021, 2025];

// ARR Potential — initial parameter set when the user first enables the layer.
// `fao` is fixed to false because the FAO toggle has been removed from the UI;
// the backend still requires the field, so we always send it as false.
export const ARR_POTENTIAL_DEFAULTS = {
  year: 2014,
  treeCover: 10,
  fao: false,
} as const;
